export const MessageDeleteModalKey = Symbol("MessageDeleteModal")
export const AlbumSortModalKey = Symbol("AlbumSortModalKey")
export const MediaDeleteModalKey = Symbol("MediaDeleteModal")
export const MediaDetailsModalKey = Symbol("MediaDetailsModal")
export const MediaEditModalKey = Symbol("MediaEditModal")
export const MediaTagsModalKey = Symbol("MediaTagsModalKey")
export const MediaViewModalKey = Symbol("MediaViewModal")
export const UploadDrawerKey = Symbol("UploadDrawer")
export const GalleryFiltersDrawerKey = Symbol("GalleryFiltersDrawer")
export const EventLinksDrawerKey = Symbol("EventLinksDrawer")
export const EventDeleteDrawerKey = Symbol("EventDeleteDrawerKey")
export const EventExtendDrawerKey = Symbol("EventExtendDrawerKey")
export const MessageEditModalKey = Symbol("MessageEditModal")
export const MediaFiltersDrawerKey = Symbol("MediaFiltersDrawer")
export const MediaMoveModalKey = Symbol("MediaMoveModal")
export const WelcomeVideoModalKey = Symbol("WelcomeVideoModal")
export const GalleryHeroCoverModalKey = Symbol("GalleryHeroCoverModal")
export const ZipExportDrawerKey = Symbol("ZipExportModal")
export const AlbumDeleteModalKey = Symbol("AlbumDeleteModalKey")
export const CommentsDrawerKey = Symbol("CommentsDrawerKey")
export const CommentDeleteModalKey = Symbol("CommentDeleteModalKey")
export const DeleteEventModalKey = Symbol("DeleteEventModalKey")
export const HostDashboardFiltersKey = Symbol("HostDashboardFiltersKey")
export const CloseEventModalKey = Symbol("CloseEventModalKey")
export const StartEventModalKey = Symbol("StartEventModalKey")
export const RedeemPackagesDrawerKey = Symbol("RedeemPackagesDrawerKey")
export const SlideshowDeleteModalKey = Symbol("SlideshowDeleteModalKey")
export const SlideshowExportDrawerKey = Symbol("SlideshowExportDrawerKey")
export const AddCoHostDrawerKey = Symbol("AddCoHostDrawerKey")
export const GuestListFiltersDrawerKey = Symbol("GuestListFiltersDrawerKey")
export const ConfirmModalKey = Symbol("ConfirmModalKey")
export const ExternalWishlistLinkModalKey = Symbol("ExternalWishlistLinkModalKey")
export const ToastInjectionKey = Symbol("ToastsProvider")
export const RsvpListFiltersDrawerKey = Symbol("RsvpListFiltersDrawerKey")
export const GuestDetailsModalKey = Symbol("GuestDetailsModalKey")
export const FlagContentModalKey = Symbol("FlagContentModalKey")
export const MediaModerateModalKey = Symbol("MediaModerateModalKey")
export const FlaggedContentFiltersDrawerKey = Symbol("FlaggedContentFiltersDrawerKey")
export const GuestbookMessageDrawerKey = Symbol("GuestbookMessageDrawerKey")
export const GuestUnlockAlbumModalKey = Symbol("GuestUnlockAlbumModalKey")
export const GuestInvitationModalKey = Symbol("GuestInvitationModal")
export const GuestReminderModalKey = Symbol("GuestReminderModal")
export const FreemiumWelcomeModalKey = Symbol("FreemiumWelcomeModalKey")
export const FreemiumUpgradePromptModalKey = Symbol("FreemiumUpgradePromptModalKey")
